export const OTHER_EQUIPMENT_OPTION = 'Other equipment'
export const OTHER_EQUIPMENT_OPTION_CODE = 'other_equipment'
